import { render } from "./Addresses.vue?vue&type=template&id=1964124e&scoped=true&ts=true"
import script from "./Addresses.vue?vue&type=script&lang=ts"
export * from "./Addresses.vue?vue&type=script&lang=ts"

import "./Addresses.vue?vue&type=style&index=0&id=1964124e&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1964124e"]])

export default __exports__